import { render, staticRenderFns } from "./SchoolMsg.vue?vue&type=template&id=0857574b&scoped=true"
import script from "./SchoolMsg.vue?vue&type=script&lang=ts"
export * from "./SchoolMsg.vue?vue&type=script&lang=ts"
import style0 from "./SchoolMsg.vue?vue&type=style&index=0&id=0857574b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0857574b",
  null
  
)

export default component.exports